<template>
  <div class="container__mcs my-3">
    <h4 class="font-weight-bold mb-4">Stack to improve your skills</h4>
    <b-row>
      <b-col class="px-3">
        <div class="grid__cards">
          <router-link
            v-for="(item, index) in learningUnits"
            :key="`${item.id}-${index}`"
            :to="{
              name: 'micro-credentials/detail',
              params: { learningUnitId: item.id }
            }"
            target="_blank"
          >
            <LearningUnitCardItem
              :class="[...itemClass, 'h-100']"
              flush
              :learning-unit="item"
              @clickItem="clickItem"
            >
            </LearningUnitCardItem>
          </router-link>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import LearningUnitCardItem from '@/views/LearningUnit/components/LearningUnitCardItem.vue';

export default {
  name: 'StackLearningUnitCardList',

  components: {
    LearningUnitCardItem
  },

  props: {
    learningUnits: {
      type: Array,
      required: true,
      default: () => []
    },
    itemClass: {
      type: [String, Array, Object],
      default: ''
    }
  },

  methods: {
    clickItem(item) {
      this.$emit('clickItem', item);
    }
  }
};
</script>

<style lang="scss" scoped>
.grid__cards {
  display: grid;
  margin: 0 auto;
  gap: 16px;
  align-items: stretch;
  justify-content: center;

  grid-template-columns: repeat(2, minmax(130px, 1fr)); /* default for small mobile size */
}

@media screen and (min-width: 375px) {
  .grid__cards {
    grid-template-columns: repeat(2, minmax(160px, 1fr));
  }
}

// medium mobile size
@media screen and (min-width: 425px) {
  .grid__cards {
    grid-template-columns: repeat(2, minmax(180px, 1fr));
  }
}

// large mobile size
@media screen and (min-width: 576px) {
  .grid__cards {
    grid-template-columns: repeat(2, minmax(260px, 1fr));
  }
}

// tablet size
@media screen and (min-width: 768px) {
  .container__mcs {
    h4 {
      font-size: 32px;
    }
  }
  .grid__cards {
    gap: 40px;
    grid-template-columns: repeat(2, minmax(340px, 1fr));
  }
}

// desktop size
@media screen and (min-width: 992px) {
  .grid__cards {
    grid-template-columns: repeat(3, minmax(290px, 1fr));
    grid-auto-rows: 552px; //fix height for desktop cards
  }
}

// large desktop size
@media screen and (min-width: 1200px) {
  .grid__cards {
    grid-template-columns: repeat(3, minmax(340px, 1fr));
  }
}
</style>
